/* eslint-disable react/require-default-props */

'use client';

import { useState, useEffect } from 'react';
import Heading from '@referralexchange/rea-ui-react/src/atoms/Heading';
import Content from '@referralexchange/rea-ui-react/src/atoms/Content';
import Button from '@referralexchange/rea-ui-react/src/atoms/Button';
import Alert from '@referralexchange/rea-ui-react/src/components/modals/Alert';
import Block from '@referralexchange/rea-ui-react/src/components/blocks/Block';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import PropTypes from 'prop-types';
import '@referralexchange/rea-ui-react/src/Utils/css';
import styles from './Success.module.scss';

export default function Failed({ isOpen = false, onClose, rateLimited = false }) {
  const [appElement, setAppElement] = useState(null);

  useEffect(() => {
    setAppElement(document.body);
  }, []);

  return (
    <Alert isOpen={isOpen} onClose={onClose} appElement={appElement} className={styles['alert-modal']}>
      <Block className={styles.success}>
        <Content className={Content.styles.center}>
          <FontAwesomeIcon
            icon={faExclamationCircle}
            size="4x"
            color="#e57373"
            className={styles.success__image__failed}
          />
          <Heading
            className={[Heading.styles.center, styles.success__heading].css()}
            tag="h3"
            type="h3"
          >
            Failed
          </Heading>
          <p className={styles.success__message}>
            {rateLimited
              ? 'You have submitted too many times. Please try again later.'
              : 'There was an error submitting your message. Please try again.'}
          </p>
          <Button onClick={onClose}>OK</Button>
        </Content>
      </Block>
    </Alert>
  );
}

Failed.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rateLimited: PropTypes.bool,
};
